import {
  Palette,
  Moon,
  Sun,
  Sparkles,
  Droplet,
  Waves,
  Anchor,
  Fish,
  Flame,
  Leaf,
  Snowflake,
  Cloud
} from 'lucide-react';

// Custom SVG: stylized octopus head + 3 visible tentacles (Kraken mark).
const Octopus = ({ className = '', size = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {/* Head/mantle */}
    <path d="M12 3c-3.9 0-7 2.8-7 6.4 0 2 1 3.6 2.4 4.6" />
    <path d="M19 9.4C19 5.8 15.9 3 12 3" />
    {/* Eyes */}
    <circle cx="9.6" cy="9" r="0.7" fill="currentColor" />
    <circle cx="14.4" cy="9" r="0.7" fill="currentColor" />
    {/* Tentacles (curly) */}
    <path d="M7.4 14 C 6.6 16, 7.8 17.5, 7 19.5 C 6.4 21, 5.2 21, 4.6 20" />
    <path d="M12 14 C 11.4 16.5, 12.6 18, 12 20.5 C 11.6 22, 13 22, 13.4 20.5" />
    <path d="M16.6 14 C 17.4 16, 16.2 17.5, 17 19.5 C 17.6 21, 18.8 21, 19.4 20" />
  </svg>
);

// Custom SVG: stylized curling wave (Great Wave-inspired).
const Wave = ({ className = '', size = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <path d="M3 16c2-3 5-3 7 0 s5 3 7-1 s3-4 4-2" />
    <path d="M3 11c2-3 5-3 7 0 s5 3 7-1" opacity="0.55" />
    <path d="M4 20h16" opacity="0.4" />
  </svg>
);

// Registry of available preview icons.
// Adding a new theme icon is as simple as adding an entry here.
export const THEME_ICON_REGISTRY = {
  octopus: { label: 'Octopus', Component: Octopus },
  wave: { label: 'Wave', Component: Wave },
  waves: { label: 'Waves', Component: Waves },
  moon: { label: 'Moon', Component: Moon },
  sun: { label: 'Sun', Component: Sun },
  sparkles: { label: 'Sparkles', Component: Sparkles },
  palette: { label: 'Palette', Component: Palette },
  droplet: { label: 'Droplet', Component: Droplet },
  anchor: { label: 'Anchor', Component: Anchor },
  fish: { label: 'Fish', Component: Fish },
  flame: { label: 'Flame', Component: Flame },
  leaf: { label: 'Leaf', Component: Leaf },
  snowflake: { label: 'Snowflake', Component: Snowflake },
  cloud: { label: 'Cloud', Component: Cloud }
};

export const THEME_ICON_KEYS = Object.keys(THEME_ICON_REGISTRY);

const ThemeIcon = ({ name = 'palette', size = 20, className = '' }) => {
  const entry = THEME_ICON_REGISTRY[name] || THEME_ICON_REGISTRY.palette;
  const Icon = entry.Component;
  // Lucide icons accept size prop as a number; custom SVGs do too.
  return <Icon className={className} size={size} />;
};

export default ThemeIcon;
